import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { AgGridReact } from "ag-grid-react";
import { ModuleRegistry, AllCommunityModule, themeAlpine } from 'ag-grid-community';
import Loader from "@client.components/Loader";
import "./DataTable.scss";
import variables from "./DataTable.scss";

// Register AG Grid modules
ModuleRegistry.registerModules([AllCommunityModule]);

export const DataTable = forwardRef(({ columns, data, isLoading }, ref) => {
  const headerHeight = parseInt(variables.cellHeight.replace("px", ""));

  return (
    <div className="data-table ag-theme-quartz">
      <div className={isLoading ? "data-table-grid loading" : "data-table-grid"}>
        <AgGridReact
          ref={ref}
          rowData={data}
          columnDefs={columns}
          theme={themeAlpine}
          gridOptions={{
            headerHeight: headerHeight,
            autoSizeColumns: true,
            getRowHeight: () => {
              return headerHeight;
            },
          }}
          defaultColDef={{
            sortable: true,
            flex: 1,
            headerClass: "data-table-header",
            cellClass: "data-table-cell",
          }}
        />
      </div>
      {isLoading && (
        <div className="data-table-loader-overlay">
          <Loader loading={true} />
        </div>
      )}
    </div>
  );
});

DataTable.displayName = "DataTable";

DataTable.propTypes = {
  data: PropTypes.array,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      sort: PropTypes.string,
    })
  ).isRequired,
};
